import FilterComercailData from "./page/FilterCommercailData";


const ComercialReport:React.FC = () =>{
    return(
        <>
          <FilterComercailData/>
        </>
    )
};
export default ComercialReport;